import { createSlice } from "@reduxjs/toolkit";
import StorageService from "utils/StorageServices";


const initialState = {
  filters: {
    company_id: StorageService.getCompanyId(),
    start_date: "",
    end_date: "",
    plan_status: 1,
    bid_status: 0,
    responses: 0,
    limit: 25,
    offset: 1,
    search: "",
    consignor_id: "",
    branch_id: "",
    from_location: "",
    to_location: "",
    vehicle_id: "",
  },
};

const planFilterSlice = createSlice({
  name: "PlanFilter",
  initialState,
  reducers: {
    updateInputValue: (state, action) => {
      state.filters = action.payload;
    },
  },

  reducers: {
    setPlanFilter: (state, action) => {
      // replace entire filter (useful for reset or API sync)
      return { ...state, ...action.payload };
    },
    resetPlanFilter: () => initialState,
    updatePlanFilterField: (state, action) => {
      // payload => { key: "search", value: "truck" }
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
});

export const { setPlanFilter, resetPlanFilter, updatePlanFilterField } = planFilterSlice.actions;
export default planFilterSlice.reducer;
